"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchProviders = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useSearchProviders = function () {
    var data = (0, swr_hooks_1.useProviders)().data;
    var _a = (0, react_1.useState)(''), searchValue = _a[0], setSearchValue = _a[1];
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setSearchValue(target.value);
    }, []);
    var onSearchClear = (0, react_1.useCallback)(function () {
        setSearchValue('');
    }, []);
    var dataFilteredBySearch = (0, react_1.useMemo)(function () {
        if (!searchValue || searchValue === '' || !data)
            return data;
        return data.filter(function (item) {
            return item.title.toLowerCase().startsWith(searchValue.toLowerCase());
        });
    }, [searchValue, data]);
    return (0, react_1.useMemo)(function () { return ({
        searchValue: searchValue,
        onSearchChange: onSearchChange,
        onSearchClear: onSearchClear,
        allProviders: dataFilteredBySearch,
    }); }, [searchValue, onSearchChange, onSearchClear, dataFilteredBySearch]);
};
exports.useSearchProviders = useSearchProviders;
